module.exports = __webpack_public_path__ + "img/528.4ee21173.jpg";